import { useEffect, useState } from 'react'

import { getSmsTickets } from '../../utilities/api'
import { PageLoadingContainer } from '../PageLoadingContainer'
import { QRTicketCard } from '../QRTicketCard'
import { supportsWalletPass } from '../../utilities/walletDevice'

import './smsTicketsWrapper.scss'

export default function SmsTicketsWrapper({ token }) {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [event, setEvent] = useState(null)
  const [tickets, setTickets] = useState([])

  useEffect(() => {
    if (!token) {
      setError('not_found')
      setLoading(false)
      return
    }

    setLoading(true)
    getSmsTickets(token)
      .then((res) => {
        setEvent(res.data?.event || null)
        setTickets(res.data?.tickets || [])
        setError(null)
      })
      .catch((err) => {
        const status = err?.response?.status
        setError(status === 410 ? 'expired' : 'not_found')
      })
      .finally(() => setLoading(false))
  }, [token])

  if (loading) {
    return (
      <PageLoadingContainer
        text="Loading your tickets"
        subtext="This only takes a moment."
        icon="ticket"
      />
    )
  }

  if (error) {
    return (
      <section className="spacer-xs full-height-wrapper background-gradient sms-tickets-page">
        <div className="sms-tickets-status">
          <h1>
            {error === 'expired' ? 'Link expired' : 'Tickets unavailable'}
          </h1>
          <p>
            {error === 'expired'
              ? 'This ticket link is no longer valid. Ask the box office to text you a new one.'
              : "We couldn't find tickets for this link. Check the text message and try again."}
          </p>
        </div>
      </section>
    )
  }

  return (
    <section className="spacer-xs full-height-wrapper background-gradient sms-tickets-page">
      <div className="section-heading-sm">
        <h1>Your tickets</h1>
      </div>
      <p className="caption text-muted sms-tickets-note">
        {supportsWalletPass()
          ? 'Show the QR code at the door, or add these tickets to your wallet.'
          : 'Show the QR code at the door. Open this page on your phone to add tickets to Apple Wallet or Google Wallet.'}
      </p>
      <div className="sms-tickets-list">
        {tickets.map((ticket) => (
          <QRTicketCard
            key={ticket.uuid || ticket.id || ticket.checkInCode}
            ticket={ticket}
            event={event}
          />
        ))}
      </div>
    </section>
  )
}
